import {useRef} from 'react';
import {VERIFICATION_METHODS} from '@chekin/api';
import type {VerificationData, VerifiedContactsPayload} from './types';

type Params = {
  isEmailEnabled?: boolean;
  isPhoneEnabled?: boolean;
  onAllVerified: (payload: VerifiedContactsPayload) => void | Promise<void>;
};

export function useVerifiedContacts({
  isEmailEnabled,
  isPhoneEnabled,
  onAllVerified,
}: Params) {
  const emailRef = useRef<VerificationData>({
    type: VERIFICATION_METHODS.email,
    data: '',
    verified: false,
  });
  const phoneRef = useRef<VerificationData>({
    type: VERIFICATION_METHODS.phone,
    data: '',
    verified: false,
  });

  const getIsAllVerified = () => {
    if (isEmailEnabled && isPhoneEnabled)
      return emailRef.current.verified && phoneRef.current.verified;
    if (isEmailEnabled) return emailRef.current.verified;
    if (isPhoneEnabled) return phoneRef.current.verified;
    return false;
  };

  return async (data: VerificationData) => {
    if (data.type === VERIFICATION_METHODS.email) emailRef.current = data;
    if (data.type === VERIFICATION_METHODS.phone) phoneRef.current = data;

    if (!getIsAllVerified()) return;

    await onAllVerified({
      default_invite_email:
        emailRef.current.verified && emailRef.current.data
          ? emailRef.current.data
          : undefined,
      default_phone_number:
        phoneRef.current.verified && phoneRef.current.data
          ? phoneRef.current.data
          : undefined,
    });
  };
}
